// Campaign attribution: capture utm_* once, keep it for the whole visit.
//
// FIRST TOUCH WINS. The visitor lands from the SMS with the campaign's utm
// set, browses, maybe reloads the page without the query string, then submits
// — the stored first-touch values are what the CRM must receive, not the
// (empty) parameters of the final page view. sessionStorage rather than
// localStorage on purpose: attribution belongs to a visit, and a doctor
// returning organically next month is a new story, not DrDay's conversion.

const STORAGE_KEY = 'parsina.campaign.utm';
export const UTM_KEYS = ['source', 'medium', 'campaign', 'content', 'term'];
const MAX_VALUE = 150;

function clean(value) {
  return typeof value === 'string' ? value.trim().slice(0, MAX_VALUE) : '';
}

export function parseUtm(search) {
  const params = new URLSearchParams(search || '');
  const utm = {};
  for (const key of UTM_KEYS) {
    const value = clean(params.get(`utm_${key}`));
    if (value) utm[key] = value;
  }
  return utm;
}

// storage is injectable so tests run without jsdom; the app passes
// window.sessionStorage. Storage access can throw (private mode) — a page
// that cannot remember attribution must still render and submit.
export function captureUtm(search, storage) {
  const fresh = parseUtm(search);
  let stored = {};
  try {
    stored = JSON.parse(storage.getItem(STORAGE_KEY) || '{}') || {};
  } catch {
    stored = {};
  }

  // First touch wins per key; fresh values only fill gaps.
  const merged = { ...fresh, ...stored };

  try {
    if (Object.keys(merged).length) storage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch {
    /* private mode — in-memory value still returned */
  }
  return merged;
}

export function currentUtm() {
  if (typeof window === 'undefined') return {};
  try {
    return captureUtm(window.location.search, window.sessionStorage);
  } catch {
    return parseUtm(typeof window !== 'undefined' ? window.location.search : '');
  }
}
